export default __webpack_public_path__ + "static/media/r4.31f35c07.jpeg";